import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import styles from './TabView.styles';

function TabView({ index, tabStyle, children, activeTab }) {
  const isShown = activeTab === index;
  if (!isShown) {
    return null;
  }
  return <View style={[styles.isShown(isShown), tabStyle]}>{children}</View>;
}

TabView.propTypes = {
  index: PropTypes.number,
  children: PropTypes.object,
  tabStyle: ViewPropTypes.style,
  activeTab: PropTypes.number,
};

export default TabView;
